import { MatterTypeNS, MatterTypeSchema } from "@smart/bridge-types-basic";
import { buildTableDef } from "@smart/itops-constructs-basic";
import { wrapSchema } from "@smart/itops-utils-basic";

const matterTypeGuard = wrapSchema(MatterTypeSchema);

export const MatterTypeDef = buildTableDef(
  {
    namespace: MatterTypeNS,
    guard: matterTypeGuard,
    keyFields: ["uri"],
    keySchema: { uri: "string" },
    ttlField: "deletedAtSec",
  } as const,
  {
    byCategory: {
      indexName: "byCategory",
      keyFields: ["category"],
      keySchema: { category: "string" },
    },
    byLocation: {
      indexName: "byLocation",
      keyFields: ["location"],
      keySchema: { location: "string" },
    },
    byType: {
      indexName: "byType",
      keyFields: ["type", "category"],
      keySchema: { type: "number", category: "string" },
    },
    byLocationAndCategory: {
      indexName: "byLocationAndCategory",
      keyFields: ["location", "category"],
      keySchema: { location: "string", category: "string" },
    },
  } as const,
);
